import React from 'react';
import {
  FiCheckCircle,
  FiGlobe,
  FiHeart,
  FiUsers,
  FiTrendingUp,
  FiTarget,
  FiZap,
  FiAward,
  FiMap,
  FiArrowRight,
  FiShield
} from "react-icons/fi";
import {
  FaShieldAlt, 
  FaBalanceScale,
  FaUsers as FaUsersIcon,
  FaGraduationCap,
  FaLightbulb,
  FaHandsHelping
} from 'react-icons/fa';
import PartnerLogosSlider from '../components/partnerlider';
import StatisticsSection from '../components/stats';

const AboutUs = () => {
  const stats = [
    { label: "Customers", value: "1.6M+", icon: <FiUsers /> },
    { label: "Sq. Kilometers", value: "57K+", icon: <FiMap /> },
    { label: "Office Locations", value: "350", icon: <FiAward /> },
  ];

  return (
    <div className="bg-white font-sans text-gray-900 selection:bg-yellow-200 overflow-x-hidden">

      {/* Hero Section */}
      <section className="relative py-14 sm:py-20 md:py-24 bg-black text-white overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&q=80&w=2070"
            alt="Power Grid"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
        </div>
        <div className="container mx-auto px-4 sm:px-6 relative z-10">
          <div className="max-w-3xl">
            <span className="inline-block px-3 py-1 mb-3 text-[10px] sm:text-xs font-bold tracking-widest uppercase bg-yellow-400 text-black rounded-full">
              Established and Proven
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
              Commited to serving you <span className="text-green-500">better.</span>
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed max-w-2xl font-normal">
              Distributing reliable energy across Delta, Edo, Ekiti, and Ondo States to over 18 million people.
            </p>
          </div>
        </div>
      </section>

      {/* Company Profile Section */}
      <section className="py-12 sm:py-16 md:py-10">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12">
            <div className="lg:w-1/2 w-full">
              <div className="flex items-center gap-2 text-green-700 font-bold mb-3">
                <div className="w-8 h-[2px] bg-yellow-400"></div>
                <span className="uppercase tracking-widest text-xs text-green-700">Who We Are</span>
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-black tracking-tight uppercase">Company  <span className="text-green-700">Profile</span></h2>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4">
              BEDC Electricity Plc is one of the successor distribution companies (Discos) created following the unbundling and privatization of the state-owned Power Utility, Power Holding Company of Nigeria Plc.  
              </p>
              <p className='mb-3'>
              BEDC is responsible for the retail distribution of electricity in Delta, Edo, Ekiti, and Ondo States with a geographical coverage of               
              <strong> 57,353 square kilometres</strong>. The company operates from 29 Business Unit Offices and 163 Service Centers within 9 regions across 4 states with MD Customers population of 7,500 while the non-MD customers are 1.683million
              </p>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6">
              BEDC is strategically located and uniquely positioned to maximize the opportunities that may arise as Nigeria’s power trading market becomes more competitive and liberalized, as there are a number of major power generations and transmission hubs located within the area.
              </p>
            </div>
            <div className="lg:w-1/2 w-full">
              <div className="relative">
                <div className="absolute -top-4 -left-4 w-48 sm:w-64 h-48 sm:h-64 bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
                <div className="relative overflow-hidden shadow-xl border-2 sm:border-4 border-black rounded-2xl bg-gray-100 flex items-center justify-center">
                  <img
                    src="/images/aboutUs1.png"
                    alt="Team collaboration"
                    className="w-full h-auto max-h-[380px] object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

            {/* Fixed Image Display */}
  <section className="py-10 bg-white">
        <div className="container mx-auto px-4 sm:px-6 flex justify-center">
          <div className="w-full max-w-6xl rounded-2xl overflow-hidden shadow-lg border bg-gray-50 flex items-center justify-center">
            <img
              src="/images/aboutUs3.png"
              alt="Metering Commitment"
              className="w-full h-auto max-h-[450px] object-contain"
            />
          </div>
        </div>
      </section>

      <section className="relative py-8 sm:py-10 bg-gradient-to-b from-white via-green-50 to-white overflow-hidden">
        <div className="container relative z-10 mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {/* Mission */}
            <div className="group relative overflow-hidden rounded-2xl sm:rounded-3xl bg-gradient-to-br from-green-700 via-green-800 to-green-950 p-6 sm:p-10 text-white shadow-xl transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/10"></div>
              <div className="relative z-10">
                <div className="mb-6 sm:mb-8 flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-2xl bg-white/10 text-2xl sm:text-3xl backdrop-blur-sm transition duration-300 group-hover:bg-white group-hover:text-green-700">
                  <FiZap />
                </div>
                <h3 className="mb-3 sm:mb-5 text-2xl sm:text-3xl font-bold uppercase">
                  Our Mission
                </h3>
                <p className="text-sm sm:text-base leading-6 sm:leading-8 text-green-100">
                  To provide reliable and safe electricity in the most cost-effective way possible, ensuring our customers stay powered 24/7.
                </p>
              </div>
            </div>

            {/* Vision */}
            <div className="group relative overflow-hidden rounded-2xl sm:rounded-3xl bg-gradient-to-br from-green-800 via-green-900 to-black p-6 sm:p-10 text-white shadow-xl transition-all duration-500 hover:-translate-y-2">
              <div className="absolute -left-10 -bottom-10 h-40 w-40 rounded-full bg-yellow-400/10"></div>
              <div className="relative z-10">
                <div className="mb-6 sm:mb-8 flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-2xl bg-yellow-400/20 text-2xl sm:text-3xl text-yellow-300 transition duration-300 group-hover:bg-yellow-400 group-hover:text-black">
                  <FiTarget />
                </div>
                <h3 className="mb-3 sm:mb-5 text-2xl sm:text-3xl font-bold uppercase">
                  Our Vision
                </h3>
                <p className="text-sm sm:text-base leading-6 sm:leading-8 text-green-100">
                  To be the leading electricity provider enabling sustainable economic and technological growth for all stakeholders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <OurValues />

      <PartnerLogosSlider />

      {/* Board of Directors Section */}
      <section className="py-6 sm:py-8">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="bg-gradient-to-r from-green-800 to-black rounded-2xl sm:rounded-3xl p-6 sm:p-10 md:p-14 border border-green-700 flex flex-col md:flex-row items-center justify-between gap-6 sm:gap-8">
            <div className="md:w-2/3 text-center md:text-left">
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4">Leadership and Governance</h2>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base leading-relaxed mb-6">
                Our board consists of seasoned industry veterans and strategic visionaries committed to transparency, excellence, and the long-term sustainability of Nigeria's energy sector.
              </p>
              <a
                href="/board-of-directors"
                className="inline-flex items-center justify-center md:justify-start gap-2 text-yellow-400 font-bold text-sm md:text-base group"
              >
                Meet our Board of Directors
                <FiArrowRight className="group-hover:translate-x-1.5 transition-transform" />
              </a>
            </div>
            <div className="md:w-1/3 flex justify-center">
              <div className="relative">
                <div className="w-28 h-28 sm:w-36 sm:h-36 rounded-full border-4 border-yellow-400/30 flex items-center justify-center">
                  <FiShield size={48} className="text-yellow-400 opacity-80 sm:w-[60px] sm:h-[60px]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Timeline */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-green-900">
              Our Journey
            </h2>
            <p className="max-w-3xl mx-auto mt-4 text-gray-600">
              From the unbundling of PHCN to becoming one of Nigeria's largest
              electricity distribution companies.
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            {[
              {
                year: "2013",
                title: "Company Formation",
                text: "Established through the privatisation of PHCN."
              },
              {
                year: "2016",
                title: "Infrastructure Expansion",
                text: "Expanded network coverage across four states."
              },
              {
                year: "2020",
                title: "Technology Adoption",
                text: "Implemented smart metering and digital initiatives."
              },
              {
                year: "Today",
                title: "Future Ready",
                text: "Driving sustainable energy transformation."
              }
            ].map((item, index) => (
              <div key={index} className="flex gap-6 mb-10">
                <div className="w-20 font-bold text-green-700">
                  {item.year}
                </div>

                <div className="relative">
                  <div className="w-5 h-5 bg-green-700 rounded-full"></div>

                  {index !== 3 && (
                    <div className="absolute left-2 top-5 w-1 h-20 bg-green-200"></div>
                  )}
                </div>

                <div>
                  <h3 className="font-bold text-xl">
                    {item.title}
                  </h3>

                  <p className="text-gray-600">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Statistics */}
      <StatisticsSection/>



      <section className="py-10 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-green-900">
              What We Do
            </h2>

            <p className="max-w-3xl mx-auto mt-4 text-gray-600">
              Delivering reliable electricity and innovative energy solutions
              to homes, businesses and industries.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              "Electricity Distribution",
              "Metering Services",
              "Network Expansion",
              "Customer Support",
              "Fault Management",
              "Energy Efficiency Programs"
            ].map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border p-8 shadow-sm hover:shadow-lg transition"
              >
                <FiZap
                  size={40}
                  className="text-green-700 mb-4"
                />

                <h3 className="font-bold text-xl">
                  {service}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-green-900 py-20 text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold">
              Why Choose Us
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              {
                title: "Reliable Service",
                icon: <FiCheckCircle />
              },
              {
                title: "Regional Expertise",
                icon: <FiGlobe />
              },
              {
                title: "Customer First",
                icon: <FiUsers />
              },
              {
                title: "Continuous Innovation",
                icon: <FiTrendingUp />
              }
            ].map((item, index) => (
              <div
                key={index}
                className="text-center"
              >
                <div className="text-5xl mb-5 text-yellow-400 flex justify-center">
                  {item.icon}
                </div>

                <h3 className="font-bold text-xl">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-green-900">
              Awards & Certifications
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              "ISO Certification",
              "Industry Excellence Award",
              "Safety Performance Recognition"
            ].map((award, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow p-8 text-center"
              >
                <FiAward
                  size={50}
                  className="text-yellow-500 mx-auto mb-4"
                />

                <h3 className="font-bold">
                  {award}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <FiHeart
              size={60}
              className="mx-auto text-green-700 mb-6"
            />

            <h2 className="text-4xl font-bold text-green-900 mb-6">
              Corporate Social Responsibility
            </h2>

            <p className="text-gray-600 leading-relaxed">
              We believe that business success goes beyond profitability.
              Through community engagement, education support, infrastructure
              investments and environmental responsibility, we continue to
              create lasting positive impact across the communities we serve.
            </p>
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="py-10 sm:py-12 bg-yellow-400">
        <div className="container mx-auto px-4 sm:px-6 text-center text-black font-bold uppercase">
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 sm:mb-3 italic">
            "Our Commitment to the Future"
          </h2>
          <p className="max-w-3xl mx-auto opacity-80 text-xs sm:text-sm md:text-base leading-relaxed font-semibold normal-case mb-6">
            As Nigeria's fourth-largest electricity distribution company, we remain committed to innovation, reliability, sustainability, and exceptional customer service. We are investing in technology, infrastructure, and people to deliver even greater value in the years ahead.
          </p>
          <a
            href="/contact"
            className="px-6 py-3 bg-black text-yellow-400 font-bold text-xs sm:text-sm rounded-lg hover:bg-gray-900 transition inline-block uppercase"
          >
            Get in Touch
          </a>
        </div>
      </section>
      
    </div>
  );
};

export default AboutUs;

const OurValues = () => {
  const valuesData = [
    {
      title: "Safety",
      icon: <FaShieldAlt />,
      description:
        "Prioritizing protection and security across all operations to ensure a dependable environment.",
    },
    {
      title: "Integrity",
      icon: <FaBalanceScale />,
      description:
        "Upholding complete transparency, accountability, and ethical standards in everything we do.",
    },
    {
      title: "Teamwork",
      icon: <FaUsersIcon />,
      description:
        "Collaborating seamlessly to leverage shared strengths and achieve mutual excellence.",
    },
    {
      title: "Continuous Learning",
      icon: <FaGraduationCap />,
      description:
        "Constantly expanding skills and adapting to improve service delivery and expertise.",
    },
    {
      title: "Innovation",
      icon: <FaLightbulb />,
      description:
        "Pioneering creative solutions and modern technologies to meet evolving customer needs.",
    },
    {
      title: "Resilience in Service",
      icon: <FaHandsHelping />,
      description:
        "Staying steadfast and committed to quality support through every challenge.",
    },
  ];

  return (
    <section className="relative w-full bg-gradient-to-b from-green-50 via-white to-white py-12 sm:py-16 overflow-hidden">
      <div className="container relative z-10 mx-auto sm:px-6">
        {/* Heading */}
        <div className="text-center sm:mb-5">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-green-900">
            Our Values
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-green-600 mx-auto rounded-full mt-3 sm:mt-4 mb-4 sm:mb-6"></div>
          <p className="max-w-2xl mx-auto text-gray-600 text-sm sm:text-base md:text-lg px-2">
            The principles that guide every decision, every partnership, and every service we deliver.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {valuesData.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl border border-green-100 shadow-md p-6 sm:p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:border-green-500"
            >
              {/* Icon */}
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-green-100 text-green-700 flex items-center justify-center text-2xl sm:text-3xl mb-5 sm:mb-6 transition-all duration-300 group-hover:bg-green-700 group-hover:text-white">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {item.description}
              </p>

              {/* Bottom Accent */}
              <div className="mt-5 sm:mt-6 h-1 w-10 sm:w-12 rounded-full bg-green-600 transition-all duration-300 group-hover:w-16 sm:group-hover:w-20"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};